import { render, staticRenderFns } from "./realized-over-time-information.vue?vue&type=template&id=6180f79c&scoped=true&"
import script from "./realized-over-time-information.vue?vue&type=script&lang=ts&"
export * from "./realized-over-time-information.vue?vue&type=script&lang=ts&"
import style0 from "./realized-over-time-information.vue?vue&type=style&index=0&id=6180f79c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6180f79c",
  null
  
)

export default component.exports